import Vue from 'vue';
import Vuetify from 'vuetify';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: '#1565C0',
        secondary: '#0D47A1',
        accent: '#FF9800',
        error: '#C62828',
        info: '#0288D1',
        success: '#2E7D32',
        warning: '#F9A825',
        anchor: '#1565C0',
        surface: '#F5F9FF',
      },
    },
  },
  icons: {
    iconfont: 'mdi',
  },
});
